var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpertBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 721,
    height: 378,
    viewBox: "0 0 721 378",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_400_4428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M724.492 137.716C740.797 100.114 673.331 81.0323 647.469 81.5936C601.086 82.4354 554.704 119.476 549.925 166.058C513.943 142.767 373.671 185.139 410.777 235.93C381.823 228.634 340.501 245.471 313.233 256.134C299.178 261.466 291.307 266.517 277.533 269.042C260.947 272.41 244.362 274.374 227.777 279.705C206.975 286.44 185.049 296.542 172.961 315.343C162.56 331.619 165.652 334.705 147.099 343.404C110.836 360.522 73.1681 372.307 34.3754 384.374C0.642601 394.756 -40.399 396.44 -70.1963 416.644C-42.9289 423.379 -2.73069 412.435 26.2233 412.435C62.7672 412.435 100.435 411.312 137.542 410.19C124.892 423.94 151.035 441.338 161.998 446.95C185.611 459.297 206.413 459.016 232.275 455.649C254.763 452.843 278.657 449.756 299.459 439.935C315.763 432.358 326.726 418.608 341.063 410.19C352.869 437.97 389.975 432.919 412.464 423.659C443.104 411.032 480.492 410.19 514.787 410.19C592.372 410.19 679.796 423.379 754.571 402.613C748.949 401.21 745.856 398.685 739.953 398.404C755.414 394.756 773.405 396.159 787.741 388.863C775.373 376.236 741.921 382.409 724.211 377.358C743.326 357.435 783.806 355.19 806.013 330.777C830.751 303.277 838.903 261.746 840.308 225.547C841.714 192.435 835.529 149.782 806.857 128.456C784.368 111.619 744.451 113.303 726.179 134.349",
    fill: "url(#paint0_linear_400_4428)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M404.874 297.945C405.998 274.654 383.229 276.338 367.206 270.726C393.348 245.751 431.86 259.501 459.409 272.971C445.072 237.052 449.289 214.603 486.676 193.277C516.192 176.44 537.837 186.542 565.667 199.45C561.731 183.736 560.607 173.915 550.206 164.655C550.206 165.216 550.206 165.496 549.925 166.058C513.943 142.767 373.671 185.139 410.777 235.93C381.823 228.634 340.5 245.471 313.233 256.134C299.178 261.466 291.307 266.517 277.533 269.042C260.947 272.409 244.362 274.374 227.777 279.705C206.975 286.44 185.048 296.542 172.961 315.343C162.56 331.619 165.652 334.705 147.099 343.404C110.836 360.522 73.168 372.307 34.3752 384.374C31.5642 385.215 29.0342 386.057 26.2231 386.618C34.6563 385.215 43.0896 384.093 51.2416 382.97C75.1357 379.603 102.122 377.358 125.735 377.358C132.763 377.358 154.127 384.374 159.749 381.287C166.777 377.358 167.339 361.644 171.555 354.067C182.237 334.986 217.376 309.17 240.426 319.272C229.182 324.603 216.532 335.828 219.906 349.578C245.486 323.2 275.565 296.542 312.39 288.124C327.288 284.756 342.749 285.318 357.367 286.159C373.952 287.562 388.851 298.506 404.874 297.945Z",
    fill: "#FFF2D1",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M493.897 350.656C471.408 333.819 431.491 335.503 413.219 356.548L411.252 360.477C412.657 357.11 413.5 354.023 413.5 351.217C401.975 363.564 394.947 379.839 397.758 396.676C422.777 368.895 447.233 351.778 485.464 356.548C490.805 357.11 497.27 358.513 504.017 360.477C501.206 357.11 497.832 353.742 493.897 350.656Z",
    fill: "#FFF2D1",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M746.81 235.339C733.879 201.104 660.511 206.155 633.524 213.171C573.649 228.324 559.031 273.783 557.344 325.415C562.967 287.533 610.755 252.456 644.488 239.548C684.405 224.115 717.856 229.727 756.649 242.916L746.81 235.339Z",
    fill: "#FFF2D1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_400_4428",
    x1: 385.148,
    y1: 81.5815,
    x2: 385.148,
    y2: 457.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2D1",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF2D1",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_400_4428"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M721 0H0V378H705C713.837 378 721 370.837 721 362V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertBg);
export default __webpack_public_path__ + "static/media/expert-bg.d0340a1fb3224679b460a1666e4daa66.svg";
export { ForwardRef as ReactComponent };